import { createSelector } from "reselect";

export const selectUrlEntryState = (state) => state.urlEntry;

export const isLoadingUrlEntries = (state) =>
  selectUrlEntryState(state)?.loadingUrlEntries;

export const selectUrlEntries = (state) =>
  selectUrlEntryState(state)?.urlEntries;

export const selectIdentifier = (state, props) =>
  props?.match?.params?.identifier;

export const selectUrlEntryById = createSelector(
  [(state, props) => props.identifier, selectUrlEntries],
  (urlEntryId, urlEntries) => {
    if (!urlEntries || urlEntries.length === 0) return false;
    if (!urlEntryId) return undefined;
    return urlEntries.find((entry) => entry.id === urlEntryId);
  },
);

export const selectUrlEntriesSortedByUpdatedAt = createSelector(
  [selectUrlEntries],
  (urlEntries) => {
    if (!urlEntries) return [];
    return [...urlEntries].sort(
      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
    );
  },
);
